import React from 'react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
const trustLine = ['Immediate digital access', 'One-time payment', 'Lifetime access', '7-day guarantee'];
export function FinalCTA() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-128" data-mp="3rsbliatxbsva">
      <div className="mx-auto w-full max-w-3xl px-5" data-id="element-129" data-mp="3rqs4uj4cvfsz">
        <div className="rounded-3xl border border-alert-500/30 bg-rose-50 px-5 py-6 text-center sm:px-8" data-id="element-130" data-mp="3ds0vfa0fuib6">
          <p className="text-[0.7rem] font-bold uppercase tracking-[0.16em] text-alert-600" data-id="element-131" data-mp="3hvqks1oxt3x9">
            ⏳ Special launch price
          </p>
          <h2 className="mt-2 font-display text-[1.5rem] font-extrabold leading-tight text-navy-900 sm:text-3xl" data-id="element-132" data-mp="33x8xu66uvvge">
            Get the Complete Clinical Route for Only $27
          </h2>
          <p className="mt-3 text-[0.9rem] leading-relaxed text-slate-600" data-id="element-133" data-mp="124cgy2q9lyod">
            The introductory price is available during the initial launch
            period. Once the launch offer ends, the regular price will apply.
          </p>
        </div>

        <div className="mt-8 rounded-3xl bg-navy-950 px-5 py-8 text-center sm:px-8" data-id="element-134" data-mp="labx8ba9cvg8">
          <h3 className="font-display text-[1.5rem] font-extrabold leading-tight text-white sm:text-3xl" data-id="element-135" data-mp="z1grsyyrqxjp">
            Ready to stop starting from zero?
          </h3>
          <div className="mt-4 space-y-3 text-[0.95rem] leading-relaxed text-slate-300" data-id="element-136" data-mp="v1psu7z39b43">
            <p data-id="element-137" data-mp="7bvgrsmlfqkw">
              The next patient with erectile dysfunction doesn’t need you to
              remember hundreds of pages of information. They need you to
              approach the consultation in a structured way.
            </p>
            <p data-id="element-138" data-mp="bauua1me4vny">
              You don’t need another massive medical textbook. You need a
              practical system that helps you navigate the clinical questions
              that arise during the consultation.
            </p>
          </div>

          <p className="mt-6 font-display text-sm font-extrabold uppercase tracking-[0.12em] text-cyan-bright" data-id="element-139" data-mp="1mq9st9u8zvl6">
            Clinical Route for Erectile Dysfunction™
          </p>
          <p className="mt-1 text-[0.85rem] font-semibold text-slate-400" data-id="element-140" data-mp="pavgowc17uib">
            Evaluate. Identify. Decide. Act. Monitor.
          </p>

          <p className="mt-6 font-display text-[3.2rem] font-extrabold leading-none text-white" data-id="element-141" data-mp="ycwdxt79mgjz">
            $27
            <span className="ml-2 align-middle font-display text-base font-bold text-slate-400" data-id="element-142" data-mp="1mvtu7huco90">
              USD
            </span>
          </p>

          <div className="mx-auto mt-6 max-w-sm" data-id="element-143" data-mp="5oqquzsqofgz">
            <CTAButton label="Yes, I want the complete Clinical Route" size="lg" tone="gold" data-id="element-144" data-mp="ank54ufuoai7" />
          </div>

          <div className="mt-6 space-y-4" data-id="element-145" data-mp="fg3n03lklrst">
            <CountdownTimer data-id="element-146" data-mp="3e4k7den2lqy1" />
            <ScarcityBar data-id="element-147" data-mp="3e3hkdhsvc8ne" />
          </div>

          <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-148" data-mp="3j33w1mt1tgu3">
            {trustLine.map(item => <li key={item} className="rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-[0.72rem] font-semibold text-slate-300" data-id="element-149" data-mp="3bjchg7fwjtkz">
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}